<template>
<div id="year">
  <router-view :year="$route.params.year"></router-view>
</div>
</template>

<script>
export default {
  name: 'mission-year'
}
</script>

<style scoped lang="less">

</style>
